const i = {
  name: "MonitoringFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 5C22 3.34772 20.6523 2 19 2H5C3.34772 2 2 3.34772 2 5V11H7.67703L9.5 15.5574L13.323 6H15.677L17.677 11H22V5Z" fill="currentColor"/>
<path d="M22 13V19C22 20.6523 20.6523 22 19 22H5C3.34772 22 2 20.6523 2 19V13H6.32297L8.32297 18H10.677L14.5 8.44258L16.323 13H22Z" fill="currentColor"/>
</svg>
  `
};
export {
  i as MonitoringFilled
};
